"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BMI_UNDER_18_NOTE () {
        return _vitals.BMI_UNDER_18_NOTE;
    },
    get CHIEF_COMPLAINT_MAX_LENGTH () {
        return _soap.CHIEF_COMPLAINT_MAX_LENGTH;
    },
    get DIAGNOSES_MAX_ITEMS () {
        return _soap.DIAGNOSES_MAX_ITEMS;
    },
    get ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT () {
        return _encounterhistory.ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT;
    },
    get ENCOUNTER_HISTORY_PAGE_SIZE_MAX () {
        return _encounterhistory.ENCOUNTER_HISTORY_PAGE_SIZE_MAX;
    },
    get ENCOUNTER_LABS_CHANGED () {
        return _encountererrors.ENCOUNTER_LABS_CHANGED;
    },
    get ENCOUNTER_LAB_LIMIT () {
        return _encountererrors.ENCOUNTER_LAB_LIMIT;
    },
    get ENCOUNTER_LAB_RESULTS_MAX () {
        return _encounterlabresults.ENCOUNTER_LAB_RESULTS_MAX;
    },
    get ENCOUNTER_LAB_SUGGESTED_MAX () {
        return _encounterlabresults.ENCOUNTER_LAB_SUGGESTED_MAX;
    },
    get ENCOUNTER_LOCKED () {
        return _encountererrors.ENCOUNTER_LOCKED;
    },
    get ENCOUNTER_NOT_AUTHOR () {
        return _encountererrors.ENCOUNTER_NOT_AUTHOR;
    },
    get EncounterAttachedLabResultSchema () {
        return _encounterlabresults.EncounterAttachedLabResultSchema;
    },
    get EncounterDetailSchema () {
        return _encounterdetail.EncounterDetailSchema;
    },
    get EncounterHistoryItemSchema () {
        return _encounterhistory.EncounterHistoryItemSchema;
    },
    get EncounterLabAttachRequestSchema () {
        return _encounterlabresults.EncounterLabAttachRequestSchema;
    },
    get EncounterLabAttachResponseSchema () {
        return _encounterlabresults.EncounterLabAttachResponseSchema;
    },
    get EncounterLabDetachResponseSchema () {
        return _encounterlabresults.EncounterLabDetachResponseSchema;
    },
    get EncounterLabResultsResponseSchema () {
        return _encounterlabresults.EncounterLabResultsResponseSchema;
    },
    get EncounterLabSourceStateSchema () {
        return _encounterlabresults.EncounterLabSourceStateSchema;
    },
    get EncounterOpenDraftOtherSchema () {
        return _encounteropendraft.EncounterOpenDraftOtherSchema;
    },
    get EncounterOpenDraftResponseSchema () {
        return _encounteropendraft.EncounterOpenDraftResponseSchema;
    },
    get EncounterSignRequestSchema () {
        return _encountersign.EncounterSignRequestSchema;
    },
    get EncounterSignResponseSchema () {
        return _encountersign.EncounterSignResponseSchema;
    },
    get EncounterSoapSchema () {
        return _encounterdetail.EncounterSoapSchema;
    },
    get EncounterStartRequestSchema () {
        return _encounterstart.EncounterStartRequestSchema;
    },
    get EncounterStartResponseSchema () {
        return _encounterstart.EncounterStartResponseSchema;
    },
    get EncounterStatusSchema () {
        return _encounterstatus.EncounterStatusSchema;
    },
    get EncounterUserRefSchema () {
        return _encounterdetail.EncounterUserRefSchema;
    },
    get EncounterVitalsSchema () {
        return _encounterdetail.EncounterVitalsSchema;
    },
    get ICD10_CODE_UNKNOWN () {
        return _encountererrors.ICD10_CODE_UNKNOWN;
    },
    get LAB_RESULT_NOT_ATTACHABLE () {
        return _encountererrors.LAB_RESULT_NOT_ATTACHABLE;
    },
    get LatestVitalsResponseSchema () {
        return _latestvitals.LatestVitalsResponseSchema;
    },
    get LatestVitalsSchema () {
        return _latestvitals.LatestVitalsSchema;
    },
    get LatestVitalsSourceSchema () {
        return _latestvitals.LatestVitalsSourceSchema;
    },
    get OPEN_DRAFT_OTHERS_MAX_ITEMS () {
        return _encounteropendraft.OPEN_DRAFT_OTHERS_MAX_ITEMS;
    },
    get PLAN_EXCERPT_MAX_LENGTH () {
        return _encounterhistory.PLAN_EXCERPT_MAX_LENGTH;
    },
    get PatientEncounterHistoryQuerySchema () {
        return _encounterhistory.PatientEncounterHistoryQuerySchema;
    },
    get PatientEncounterHistoryResponseSchema () {
        return _encounterhistory.PatientEncounterHistoryResponseSchema;
    },
    get SOAP_INCOMPLETE () {
        return _encountererrors.SOAP_INCOMPLETE;
    },
    get SOAP_TEXT_MAX_LENGTH () {
        return _soap.SOAP_TEXT_MAX_LENGTH;
    },
    get SOAP_VERSION_CONFLICT () {
        return _encountererrors.SOAP_VERSION_CONFLICT;
    },
    get SoapUpdateRequestSchema () {
        return _soap.SoapUpdateRequestSchema;
    },
    get SoapUpdateResponseSchema () {
        return _soap.SoapUpdateResponseSchema;
    },
    get VITALS_RANGES () {
        return _vitals.VITALS_RANGES;
    },
    get VITALS_VERSION_CONFLICT () {
        return _encountererrors.VITALS_VERSION_CONFLICT;
    },
    get VitalsInputSchema () {
        return _vitals.VitalsInputSchema;
    },
    get VitalsSaveRequestSchema () {
        return _vitals.VitalsSaveRequestSchema;
    },
    get VitalsSaveResponseSchema () {
        return _vitals.VitalsSaveResponseSchema;
    },
    get bmiCategory () {
        return _vitals.bmiCategory;
    },
    get computeBmi () {
        return _vitals.computeBmi;
    },
    get parseBloodPressure () {
        return _vitals.parseBloodPressure;
    },
    get planExcerpt () {
        return _encounterhistory.planExcerpt;
    }
});
const _encounterstatus = require("./encounter-status");
const _vitals = require("./vitals");
const _soap = require("./soap");
const _encounterstart = require("./encounter-start");
const _encountersign = require("./encounter-sign");
const _encounteropendraft = require("./encounter-open-draft");
const _latestvitals = require("./latest-vitals");
const _encounterdetail = require("./encounter-detail");
const _encounterlabresults = require("./encounter-lab-results");
const _encounterhistory = require("./encounter-history");
const _encountererrors = require("./encounter-errors");
